// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import 'zone.js/dist/zone-error'
export const environment = {

production: true, 
//  baseUrl: 'http://localhost:8081/',
baseUrl: 'https://webapi.r2.rpost.net/',

 ActAPIbaseUrl:'https://activitytrackerapi.r2.rpost.net/',
 //apiKey: '2FuZ3VsaUByc4AzdC5jb20iLCJTZXNzaW9uSWQiOiJmMzc0MjVl',
 productLine: 'RMail',//use RMailPrime for prime
 AccessbaseUrl:'https://rmailif.r2.rpost.net/',
 AccessUrl:'AutolockAccessDecision',
apiKey: '2FuZ3VsaUByc4AzdC5jb20iLCJTZXNzaW9uSWQiOiJmMzc0MjVl',
WebAPIv2Url:'https://webapi5.r2.rpost.net/',
DiinkRefUrl:'https://redact.r2.rpost.net/diink/{shortURL}',
EdiinkRefUrl:'https://redact.r2.rpost.net/ediink/{shortURL}/{lang}',
ViewTextRefUrl:'https://redact.r2.rpost.net/ViewText/{shortURL}',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
